import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NEVER, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ShippingInventryService } from '@apiServices';
import {
  HelperService,
  ModalService,
  ToastrService,
} from 'src/app/core/services/index.service';
import {
  debounceTime,
  distinctUntilChanged,
  first,
  switchMap,
  throttleTime,
} from 'rxjs/operators';
import {
  PaginationKRoll,
  PatientType,
  SearchBy,
} from 'src/app/core/constants/KRollConstants';
import { ModalPopup, SortType } from 'src/app/core/constants/constants';
import { signatureItems } from 'src/app/core/constants/signatureConstants';
import { RouteConstants } from 'src/app/core/constants/RouteConstants';
import { AddGroupComponent } from 'src/app/core/modals/add-group/add-group.component';
import { FormService } from 'src/app/core/services/form.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SenderInformationComponent } from 'src/app/core/modals/sender-information/sender-information.component';
import { CommonService } from 'src/app/core/services/api-services/common.service';
import { KRollService } from 'src/app/core/services/api-services/kroll.service';
import { ShippingService } from 'src/app/core/services/api-services/shipping.service';
import { SignatureModalComponent } from '../../../core/modals/signature-modal/signature-modal.component';
import { UserPromoComponent } from '../user-promo/user-promo.component';
import { RemoveAcAppliedModal } from '../remove-ac-applied-modal/remove-ac-applied-modal.component';
import { VisitService } from 'src/app/core/services/wylo-services/visit.service';
import * as CryptoJS from 'crypto-js';
import { ConfirmationRxBeforeCreateComponent } from './confirmation-rx-before-create/confirmation-rx-before-create.component';
import { DeleteConfirmPopUpComponent } from 'src/app/core/modals/delete-confirm-pop-up/delete-confirm-pop-up.component';
import { PatientDashboardService } from 'src/app/patient-dashboard/patient-dashboard.service';
import { UpdateOrderRxidsComponent } from 'src/app/core/modals/update-order-rxids/update-order-rxids.component';
import { AddressMatchPopupComponent } from 'src/app/core/modals/address-match-popup/address-match-popup.component';

@Component({
  selector: 'app-create-order',
  templateUrl: './create-order.component.html',
  styleUrls: ['./create-order.component.scss'],
})
export class CreateOrderComponent implements OnInit {
  progress_spinner: boolean = false;
  isProcessOrderLoading: boolean = false;
  isCheckRateLoading: boolean = false;
  isRxSubmitLoading: boolean = false;
  nursingHomeItems = new FormControl();
  nursingHomes: any[] = [];
  selectable = true;
  removable = true;
  addOnBlur = true;
  forWylo = false;
  tenant: any = localStorage.getItem('tenant')
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  discoverServiceList: any = [];
  discoverServiceValue = '';
  optionList: any = [
    {
      OptionCode: 'SO',
      OptionName: 'Signature option',
      OptionClass: 'FEAT',
      desableOption: ['LAD'],
      autoCheckOption: [],
    },
    {
      OptionCode: 'PA18',
      OptionName: 'Proof of age required (18 years)',
      OptionClass: 'DI',
      desableOption: ['SO', 'PA19', 'PA21', 'DNS', 'LAD'],
      autoCheckOption: ['SO'],
    },
    {
      OptionCode: 'PA19',
      OptionName: 'Proof of age required (19 years)',
      OptionClass: 'DI',
      desableOption: ['SO', 'PA18', 'PA21', 'DNS', 'LAD'],
      autoCheckOption: ['SO'],
    },
    {
      OptionCode: 'PA21',
      OptionName: 'Proof of age required (21 years)',
      OptionClass: 'DI',
      desableOption: ['SO', 'PA18', 'PA19', 'DNS', 'LAD'],
      autoCheckOption: ['SO'],
    },
    {
      OptionCode: 'HFP',
      OptionName: 'Card for pick-up',
      OptionClass: 'NDI',
      desableOption: ['DNS', 'LAD'],
      autoCheckOption: [],
    },
    {
      OptionCode: 'DNS',
      OptionName: 'Do not safe drop',
      OptionClass: 'NDI',
      desableOption: ['PA18', 'PA19', 'PA21', 'LAD', 'HFP'],
      autoCheckOption: [],
    },
    {
      OptionCode: 'LAD',
      OptionName: 'Leave at door - do not card',
      OptionClass: 'NDI',
      desableOption: ['SO', 'PA18', 'PA19', 'PA21', 'DNS', 'HFP'],
      autoCheckOption: [],
    },
  ];
  isShowCanadaPost: boolean = false;

  selectedTabIndex: number = 0;
  PatientType = PatientType;
  SortType = SortType;
  config = {
    id: 'server',
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: 0,
  };
  signatureItems = signatureItems;
  paginationObj: PaginationKRoll = {
    page: 1,
    per_page: this.config.itemsPerPage,
    shipping_type: PatientType.Chronic,
    search_value: [],
    server_location: 0,
    sort_type: '',
    sort_key: '',
    search_by: SearchBy.Kroll,
    orders: 'sale',
    create_pagination: 0,
    order_status: [],
  };
  response = {
    list: new Array(),
    pagination: {
      total: 0,
      last: 0,
    },
  };
  sort(key: any) {
    this.paginationObj.sort_key = key;
    this.paginationObj.sort_type =
      this.paginationObj.sort_type == SortType.Ascending
        ? SortType.Descending
        : SortType.Ascending;
  }
  serverLocations: any[] = [];
  selectedServerLocationId: number = 0;
  serverLocationSubscription: Subscription = new Subscription();
  addDeliveryPartnerSubscription: Subscription = new Subscription();

  inventryType: { rx_inventory_types: any[]; ship_inventory_types: any[] } = {
    rx_inventory_types: [],
    ship_inventory_types: [],
  };
  location: { all_states: any[]; rx_states: any[]; ship_states: any[] } = {
    all_states: [],
    rx_states: [],
    ship_states: [],
  };
  deliveryPartners: any[] = new Array();

  acuteDataFound: boolean = false;
  chronicDataFound: boolean = false;

  senderInformation: any = {
    selectedDeliveryPartner: '',
  };
  selectedPaitents: {
    [PatientType.Chronic]: any[];
    [PatientType.Acute]: any[];
    [PatientType.Null]: any[];
  } = {
      [PatientType.Chronic]: [],
      [PatientType.Acute]: [],
      [PatientType.Null]: [],
    };
  IsQuebec: boolean = false;

  processOrderPayload: any;
  @ViewChild('mtg') matTab: any;
  isDeliveryCostColumnShow: boolean = false;
  searchForm: FormGroup = new FormGroup({});
  private encryptionKey = 'VisitModule';
  vid: number = 0;
  isShowMWSPost: boolean = false;
  orderOptions: any[] = [];
  clientOptions: any[] = [];
  mwsOptionList: any[] = [];
  currentDate: string | undefined;
  deliveryDates: any = {};
  tagsValue: any;
  sendDeliveryDate: any = '';
  serverLocation: any = localStorage.getItem('serverLocation');

  constructor(
    public dialog: MatDialog,
    public shippingInventryService: ShippingInventryService,
    public krollService: KRollService,
    public helperService: HelperService,
    private route: ActivatedRoute,
    private router: Router,
    public modalService: ModalService,
    public formService: FormService,
    public RouteConstants: RouteConstants,
    public fb: FormBuilder,
    public shippingService: ShippingService,
    public commonService: CommonService,
    private cdr: ChangeDetectorRef,
    public toastr: ToastrService,
    private visitService: VisitService,
    public patientService: PatientDashboardService
  ) {
    this.serverLocations = this.route.snapshot.data.appData.serverLocations;
    this.deliveryPartners = this.route.snapshot.data.appData.deliveryPartner;
    this.paginationObj.server_location = this.formService.selectedLocation.value || 0;
    this.getLocationId();

    if (this.paginationObj.shipping_type === PatientType.Chronic) {

      if (this.nursingHomes.find((f) => f.ID == this.paginationObj.search_value[0])) {
        this.nursingHomeItems.setValue(this.paginationObj.search_value[0]);
      }
      else {
        this.paginationObj.search_value = [];
      }

    }
    //console.log("Server Location ",this.formService.selectedLocation.value);

    if (this.formService.selectedLocation.value == 9) { this.IsQuebec = true; }
    else { this.IsQuebec = false }
  }

  ngOnInit(): void {
    this.vid = this.decryptAndGetCode(this.route.snapshot.paramMap.get('vid'));

    this.getSenderInformation();
    this.deliveryPartnerChange();
    this.getNursingHome();

    this.searchFormInitialize();
    this.searchFormEvent();
    this.get_options();
    this.getUpdatedDiscoveryService();
  }

  decryptAndGetCode(_vid: any): any {
    const encryptedValue = _vid;
    if (encryptedValue) {
      const bytes = CryptoJS.AES.decrypt(encryptedValue, this.encryptionKey);
      const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decrypted;
    }
  }

  searchFormInitialize() {
    this.searchForm = new FormGroup({
      search: new FormControl(this.paginationObj.search),
    });
  }
  searchFormEvent() {
    this.searchForm.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((formObj) => {
          this.paginationObj.search_by = SearchBy.Local;
          this.paginationObj = { ...this.paginationObj, ...formObj };
          if (
            formObj.search == '' ||
            Object.values(formObj).some((s) => s != null && s != '')
          ) {
            this.paginationObj.page = this.config.currentPage = 1;
            this.changeRoute();
            return NEVER;
          } else {
            return NEVER;
          }
        })
      )
      .subscribe(console.log);
  }
  resetForm() {
    this.searchForm.reset();
    this.paginationObj.page = this.config.currentPage = 1;
    this.paginationObj.search = '';
    this.changeRoute();
  }
  getNursingHome() {
    this.krollService.nursingHomes.subscribe(
      (res) => (this.nursingHomes = res)
    );
  }
  ngAfterViewInit(): void {
    if (window.history.state?.shipping_type) {
      let shipping_type = window.history.state.shipping_type;
      this.paginationObj.shipping_type = shipping_type;
      if (shipping_type == PatientType.Chronic) {
        this.selectedTabIndex = 0;
      } else if (shipping_type == PatientType.Acute) {
        this.tenant == 'wylo' ? this.selectedTabIndex = 0 : this.selectedTabIndex = 1;
      } else {
        this.selectedTabIndex = 2;
      }

      this.matTab.selectedIndex = this.selectedTabIndex;
    }
  }
  get_patient_orders() {
    this.progress_spinner = true;
    this.acuteDataFound = true;
    this.chronicDataFound = true;
    this.paginationObj.order_status =
     this.formService.getSalesOrderFormStatusArr.value.map((m: any) => m.id);
    if (this.tenant == 'wylo') {
      this.paginationObj.shipping_type = this.PatientType.Acute;
    }
    this.krollService.get_patient_orders(this.paginationObj).subscribe(
      (res) => {
        if (res['body']['success']) {
          const hasKrollIdUsersIssue = (res?.body?.krollIdUsersIssue && Object.keys(res.body.krollIdUsersIssue).length > 0 && (this.tenant == 'sl' || this.tenant == 'pl'));
          if (hasKrollIdUsersIssue) {
            this.openUpdateOrderRxidsModal([res.body.krollIdUsersIssue]);
          }
          this.progress_spinner = false;
          this.krollService.get_sales_order_status({ server_location: this.formService.selectedLocation.value, });
          this.paginationObj.search_by = SearchBy.Local;
          this.paginationObj.create_pagination = 1;
          this.response.list = res['body']['data'].list;
          this.response.pagination = res['body']['data'].pagination;
          this.config.totalItems = this.response.pagination['total'];
          (window as any).isCreateOrderUnsaveChange = true;
          let addDeliveryPartner = this.formService.addDeliveryPartner.value;
          // filter list and find delivery partnerID == 9
          const filteredList = this.response.list.filter((item: any) => item.DeliveryPartnerID == 9);
          this.initializeDeliveryDate(filteredList);
          if ((this.tenant == 'pl' || this.tenant == 'sl') && this.serverLocation == 1) {
            this.getMWSOptions();
          }
          let canShowCanadaPost = false;
          let canShowMWSPost = false;
          if (addDeliveryPartner == 13 || addDeliveryPartner === null || addDeliveryPartner === '') {
            canShowCanadaPost = true;
          } else if ((addDeliveryPartner == 9 || addDeliveryPartner === null || addDeliveryPartner === '') && this.serverLocation == 1) {
            canShowMWSPost = true;
          }
          //console.log("canShowCanadaPost",canShowCanadaPost)
          this.response.list = this.response.list.map((m) => ({
            ...m,
            isShowCanadaPostOption: m?.deliver_partner?.type === 'canada_post' && (canShowCanadaPost || m?.DeliveryPartnerID === 13),
            isShowMWSPostOption: m?.deliver_partner?.type == 'mws' && this.serverLocation == 1 && (canShowMWSPost || m?.DeliveryPartnerID == 9),
            ServiceCode: m.service_code,
            OptionCode: m.option_code,
          }));
          this.response.list.map((item: any) => {
            this.shippingService.deliveryPartnerName =
              item?.deliver_partner?.name;
            if (item?.deliver_partner?.type == 'canada_post' && canShowCanadaPost == true) {
              this.isShowCanadaPost = true;
              this.isShowMWSPost = false;
            } else if (item?.deliver_partner?.type == 'mws' && this.serverLocation == 1 && canShowMWSPost == true) {
              this.isShowCanadaPost = false;
              this.isShowMWSPost = true;
            } else {
              this.isShowCanadaPost = false;
              this.isShowMWSPost = false;
            }
          });
          /* console.log('addDeliveryPartner Bahar',addDeliveryPartner); */
          /* isShowCanadaPost */
          if (addDeliveryPartner) {
            /* console.log('addDeliveryPartner Andar',addDeliveryPartner); */
            this.response.list = this.response.list.map((m) => ({
              ...m,
              DeliveryPartnerID: addDeliveryPartner,
              isShowCanadaPostOption: m?.deliver_partner?.type == 'canada_post' && canShowCanadaPost == true ? true : false,
              isShowMWSPostOption: m?.deliver_partner?.type == 'mws' && canShowMWSPost == true && this.serverLocation == 1 ? true : false,
              ServiceCode: m.service_code,
              OptionCode: m.option_code,
            }));
          }
          this.get_discover_services_general();
          let matchingSelectedPaitentsList = this.response.list.filter((f) =>
            this.selectedPaitents[this.paginationObj.shipping_type]
              .map((m) => m.ID)
              .includes(f.ID)
          );
          if (matchingSelectedPaitentsList.length > 0) {
            matchingSelectedPaitentsList.forEach((element) => {
              let index = this.selectedPaitents[
                this.paginationObj.shipping_type
              ].findIndex((f) => f.ID == element.ID);
              this.selectedPaitents[this.paginationObj.shipping_type][index] =
                element;
            });
          }
          if (this.formService.addDeliveryPartner.value == 13) {
            this.isShowCanadaPost = true;
            this.isShowMWSPost = false;
            this.response.list = this.response.list.map((m) => ({
              ...m,
              isShowCanadaPostOption: true,
              isShowMWSPostOption: false,
            }));
          } else if (this.formService.addDeliveryPartner.value == 9) {
            this.isShowCanadaPost = false;
            this.isShowMWSPost = true;
            this.response.list = this.response.list.map((m) => ({
              ...m,
              isShowCanadaPostOption: false,
              isShowMWSPostOption: true,
            }));
          } else {
            this.isShowCanadaPost = false;
            this.isShowMWSPost = false;
          }
          this.isShowCanadaPost = this.response.list.some(item => item.isShowCanadaPostOption === true);
          this.isShowMWSPost = this.response.list.some(item => item.isShowMWSPostOption === true);
          if (this.tenant == 'wylo') {
            this.toastr.success("Order Created Successfully");
            // this.router.navigate([this.RouteConstants.Visits.UsersMedications.Route+'/'+this.vid], { queryParams: {tab: 'order'}})
            const route = this.RouteConstants.SalesOrder.SalesOrder.Route;
            const queryParams = this.helperService.salseOrderQueryParams(this.RouteConstants.SalesOrder.SalesOrder.QueryParams);
            this.router.navigate([route], { queryParams });
          }
        } else {
          this.toastr.error(res['body']['message'][0] || res['body']['message']);
          this.chronicDataFound = false;
          this.acuteDataFound = false;
          this.progress_spinner = false;
          this.response.list = [];
          this.config.totalItems = 0;
          (window as any).isCreateOrderUnsaveChange = false;
        }
        this.isRxSubmitLoading = false;

      },
      (error) => {
        this.chronicDataFound = false;
        this.acuteDataFound = false;
        this.progress_spinner = false;
        this.toastr.error(error.message);
        this.response.list = [];
        this.config.totalItems = 0;
        (window as any).isCreateOrderUnsaveChange = false;
        this.isRxSubmitLoading = false;
      }
    );
  }

  openUpdateOrderRxidsModal(item: any) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.disableClose = true; // Prevent closing the dialog on outside click
    dialogConfig.data = { item };
    if (window.innerWidth < 768) {
      // Mobile view
      dialogConfig.width = "90%";
    } else {
      // Desktop view
      dialogConfig.width = "60%";
    }
    dialogRef = this.dialog.open(UpdateOrderRxidsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.toastr.success(res?.response?.message || 'Order Rxids updated successfully');
      }
    });
  }

  getMWSOptions() {
    this.krollService.getMWSOptions().subscribe({
      next: (res) => {
        if (res?.success && Array.isArray(res?.data)) {
          this.mwsOptionList = res.data;
          this.orderOptions = this.mwsOptionList.filter((opt) => opt.type.toLowerCase() === 'order');
          this.clientOptions = this.mwsOptionList.filter((opt) => opt.type.toLowerCase() === 'client');

          if (!this.tagsValue) this.tagsValue = {};

          // Pre-checked values set karna + tagsValue update karna
          this.response.list = this.response.list.map((item) => {
            const selectedOrderTags = this.orderOptions
              .filter((opt) => item.user?.mws_tags?.includes(opt.label))
              .map((opt) => opt.info.id);

            const selectedClientTags = this.clientOptions
              .filter((opt) => item.user?.mws_tags?.includes(opt.label))
              .map((opt) => opt.info.id);

            item.OptionCode = [...selectedOrderTags, ...selectedClientTags];

            this.tagsValue[item.ID] = {
              order_tag: selectedOrderTags.map(id => {
                const opt = this.orderOptions.find(opt => opt.info.id === id);
                return opt ? {
                  type: opt.type,
                  label: opt.label,
                  shortLabel: opt.shortLabel,
                  icon: opt.icon,
                  color: opt.color,
                  system: opt.system
                } : null;
              }).filter(opt => opt !== null),

              client_tag: selectedClientTags.map(id => {
                const opt = this.clientOptions.find(opt => opt.info.id === id);
                return opt ? {
                  type: opt.type,
                  label: opt.label,
                  shortLabel: opt.shortLabel,
                  icon: opt.icon,
                  color: opt.color,
                  system: opt.system
                } : null;
              }).filter(opt => opt !== null),
            };


            return item;
          });

        } else {
          // console.error("something went wrong while calling mws tag API", res);
          // this.toastr.error("No valid data found.");
        }
      },
      error: (error) => {
        console.error('API Error:', error);
        this.toastr.error(error?.message || "An error occurred while fetching data.");
      },
    });
  }

  getTooltip(id: any): string {
    const allOptions = [...(this.orderOptions || []), ...(this.clientOptions || [])];
    const matchedItem = allOptions.find(item => item?.info?.id === id);
    return matchedItem?.info?.tooltip || '';
  }

  pageChange(currentPage: number) {
    this.paginationObj.page = currentPage;
    this.changeRoute();
  }
  ship(item: any) {
    return item.Address2 == 'DO NOT SHIP' ? false : true;
  }
  shipChange(ev: any, item: any) {
    let { checked } = ev;
    if (checked) item.Address2 = 'SHIP';
    else item.Address2 = 'DO NOT SHIP';
  }
  getLocationId() {
    this.serverLocationSubscription =
      this.formService.selectedLocation.valueChanges
        .pipe(distinctUntilChanged(), throttleTime(1000))
        .subscribe((val: any) => {
          this.selectedServerLocationId = val;
          this.paginationObj.server_location = val;
          if (this.tenant == 'wylo') this.forWylo = true
          this.changeRoute();
        });
  }
  onTabChanged(index: any) {
    if (this.response.list.length == 0) {
      this.selectedTabIndex = index;
      this.paginationObj.search_value = [];
      this.nursingHomeItems.setValue(null);
      this.paginationObj.shipping_type =
        index == 0 ? PatientType.Chronic : PatientType.Acute;
    } else if (this.selectedTabIndex != index) {
      this.modalService.UnsaveChangesDialog().subscribe((val) => {
        if (val) {
          this.selectedTabIndex = index;
          if (index == 0) {
            this.paginationObj.shipping_type = PatientType.Chronic;
            this.paginationObj.search_value = [];
          } else {
            this.nursingHomeItems.setValue(null);
            this.paginationObj.shipping_type = PatientType.Acute;
            this.paginationObj.search_value = [];
          }
          this.formService.addDeliveryPartner.setValue(null);
          this.response.list = [];
          this.acuteDataFound = false;
          this.chronicDataFound = false;
        } else {
          this.matTab.selectedIndex = this.selectedTabIndex;
        }
      });
    }
  }

  changeRoute() {
    if (!this.forWylo) {
      this.get_patient_orders();
      this.nursingHomeItems.setValue(this.paginationObj.search_value[0]);
    }
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if (
      (value || '').trim() &&
      !this.paginationObj.search_value.includes(value)
    ) {
      this.paginationObj.search_value.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
  }
  remove(val: any): void {
    const index = this.paginationObj.search_value.indexOf(val);
    if (index >= 0) {
      this.paginationObj.search_value.splice(index, 1);
    }
  }
  getInventryType() {
    this.shippingInventryService.inventryType.subscribe(
      (res) => (this.inventryType = res)
    );
  }
  getLocation() {
    this.shippingInventryService.location.subscribe(
      (res) => (this.location = res)
    );
  }

  openPackagingDialog(item: any) {
    this.modalService.openPackagingDialog(
      item,
      this.paginationObj.shipping_type
    );
    this.modalService.dialogRef.componentInstance.action.subscribe(
      (resp: any) => {
        if (resp.ModalPopup == ModalPopup.ChangePackaging) {
          item.Packaging =
            resp.data.length > 0
              ? resp.data
                .map((m: any) => `${m.inventory_types.type}(${m.Quantity})`)
                .join(',')
              : 'N/A';
          item.PackagingCost =
            resp.data.length > 0
              ? resp.data
                .reduce((acc: number, val: any) => acc + val.Price, 0)
                .toFixed(2)
              : 'N/A';
          item.sale_order_rx_packagings = resp.data;
        }
      }
    );
  }
  openAddGroupDialog() {
    const dialogConfig = new MatDialogConfig();
    if (window.innerWidth < 768) {
      dialogConfig.width = '90%';
    } else {
      dialogConfig.width = '30%';
    }
    this.dialog.open(AddGroupComponent, dialogConfig);
  }
  getSenderInformation() {
    const payload = {
      Location: this.formService.selectedLocation.value,
    };
    this.shippingService
      .get_sender_information(payload)
      .pipe(first())
      .subscribe((res: any) => {
        if (res.body?.success) {
          this.senderInformation = res.body.data;
        } else {
          this.toastr.error(res.body.message[0]);
        }
      });
  }
  deliveryPartnerChange() {
    this.addDeliveryPartnerSubscription =
      this.formService.addDeliveryPartner.valueChanges
        .pipe(distinctUntilChanged(), throttleTime(1000))
        .subscribe((value: any) => {
          this.senderInformation.selectedDeliveryPartner = value;
          this.response.list = this.response.list.map((m) => ({
            ...m,
            DeliveryPartnerID: value,
          }));
          this.selectedPaitents[this.paginationObj.shipping_type] =
            this.selectedPaitents[this.paginationObj.shipping_type].map(
              (m) => ({ ...m, DeliveryPartnerID: value })
            );
        });
  }
  get filterPatientList() {
    return (
      this.paginationObj.shipping_type &&
      this.response.list.filter((f: any) =>
        this.selectedPaitents[this.paginationObj.shipping_type]
          .map((m: any) => m.ID)
          .includes(f.ID)
      )
    );
  }
  get isAllChecked() {
    return this.response.list.length == this.filterPatientList?.length;
  }
  get indeterminateChecked() {
    return (
      this.response.list.length > this.filterPatientList?.length &&
      this.filterPatientList?.length > 0
    );
  }
  get isProcessPaymentEnable() {
    let orders = this.filterPatientList ? this.filterPatientList : [];
    return orders.length > 0 && orders.some((s) => s.PaymentDue > 0);
  }
  isCheckRate = (id: number) =>
    ['local_delivery_partner', 't_side', 'mws'].includes(
      this.deliveryPartners.find((f) => f.id == id).type
    )
      ? false
      : true;
  get isCheckRateEnable() {
    if (
      this.isCheckRateLoading ||
      !(
        this.filterPatientList &&
        this.filterPatientList.length > 0 &&
        this.filterPatientList.some(
          (s: any) =>
            s.DeliveryPartnerID && this.isCheckRate(s.DeliveryPartnerID)
        )
      )
    ) {
      return true;
    }
    return false;
  }
  get isProcessOrderEnable() {
    let orders = this.filterPatientList ? this.filterPatientList : [];
    return orders.length > 0 && orders.some((s: any) => s.DeliveryPartnerID);
  }
  setAllOrderSelected(isChecked: boolean) {
    if (isChecked && this.paginationObj.shipping_type) {
      this.selectedPaitents[this.paginationObj.shipping_type] =
        this.selectedPaitents[this.paginationObj.shipping_type]
          .concat(this.response.list)
          .filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.ID === item.ID)
          );
    } else {
      if (this.paginationObj.shipping_type) {
        let filterCurrentPageArr = this.selectedPaitents[
          this.paginationObj.shipping_type
        ].filter((f) => !this.response.list.map((m) => m.ID).includes(f.ID));
        this.selectedPaitents[this.paginationObj.shipping_type] =
          filterCurrentPageArr;
      }
    }
  }
  onCheckChange(event: MatCheckboxChange, item: any) {
    let selectedPaitents =
      this.selectedPaitents[this.paginationObj.shipping_type];
    if (event.checked) {
      let isExists = selectedPaitents.find((f: any) => f.ID === item.ID);
      if (!isExists) {
        selectedPaitents.push(item);
      }
    } else {
      let selectedIndex = selectedPaitents.findIndex(
        (f: any) => f.ID === item.ID
      );
      if (this.selectedTabIndex >= 0) {
        selectedPaitents.splice(selectedIndex, 1);
      }
    }
    this.selectedPaitents[this.paginationObj.shipping_type] = selectedPaitents;
  }
  isChecked(item: any): boolean {
    if (
      this.selectedPaitents[this.paginationObj.shipping_type] &&
      this.selectedPaitents[this.paginationObj.shipping_type].length > 0
    ) {
      let itemFind = this.selectedPaitents[
        this.paginationObj.shipping_type
      ].find((f) => f.ID === item.ID);
      if (itemFind) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  openWarningDialog(item: any) {
    this.modalService.openWarningDialog(
      item,
      this.get_patient_orders.bind(this)
    );
  }

  ngOnDestroy(): void {
    this.serverLocationSubscription.unsubscribe();
    this.addDeliveryPartnerSubscription.unsubscribe();
    this.formService.addDeliveryPartner.setValue(null);
  }

  async onCheckRateClick() {
    if (this.filterPatientList) {
      this.isDeliveryCostColumnShow = true;
      let data: any = {};
      this.isCheckRateLoading = true;
      await this.shippingService
        .setCheckRatePayload(
          this.senderInformation,
          this.filterPatientList.filter((f: any) =>
            this.isCheckRate(f.DeliveryPartnerID)
          ),
          this.formService.selectedLocation.value
        )
        .then((result) => {
          this.isCheckRateLoading = false;
          data = result;
          this.openSenderInfoDialog(data);
        });
    }
  }

  openSenderInfoDialog(item: any) {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = { item: item, deliveryPartners: this.deliveryPartners };
    if (window.innerWidth < 768) {
      dialogConfig.width = '90%';
      dialogConfig.height = '80%';
    } else {
      dialogConfig.width = '60%';
      dialogConfig.height = '90%';
    }
    dialogRef = this.dialog.open(SenderInformationComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
      if (res?.response?.data) {
        let { data } = res.response;
        if (data.length > 0) {
          data.forEach((f: any) => {
            let itemIndex = this.response.list.findIndex(
              (r) => r.OrderID === f.OrderID
            );
            if (itemIndex >= 0) {
              if (!f.Success) {
                this.response.list[itemIndex].DeliveryCost = 'N/A';
              } else {
                this.response.list[itemIndex].DeliveryCost =
                  f.TotalPrice ?? '0';
              }
            }
          });
        }
      }
    });
  }

  onNursingHomeSubmit() {
    if (this.isRxSubmitLoading) {
      return;
    }
    this.paginationObj.search_value = [];
    if (this.nursingHomeItems.value) {
      this.isRxSubmitLoading = true;
      this.paginationObj.search_value.push(this.nursingHomeItems.value);
      this.paginationObj.search_by = SearchBy.Kroll;
      this.paginationObj.create_pagination = 0;
      this.changeRoute();
    }
  }

  rxIdSubmit() {
    if (this.isRxSubmitLoading) {
      return;
    }
    this.isRxSubmitLoading = true;

    let arr = this.paginationObj.search_value.map((item) => {
      let nameRegexp = /^[0-9]*$/;
      return !nameRegexp.test(item);
    });
    if (arr.some((item) => item === true)) {
      this.toastr.error('Rx ID can only contain numbers[0-9]');
      this.isRxSubmitLoading = false;
      return;
    }

    if (this.tenant != 'wylo') {
      //item.isShowCanadaPostOption = true;

      if (this.paginationObj.search_value.length > 0) {
        this.paginationObj.search_by = SearchBy.Kroll;
        this.paginationObj.create_pagination = 0;
        this.changeRoute();
      } else {
        this.isRxSubmitLoading = false;
      }
    } else {
      const triggerSearch = (): boolean => {
        if (this.paginationObj.search_value.length > 0) {
          this.paginationObj.search_by = SearchBy.Kroll;
          this.paginationObj.create_pagination = 0;
          this.paginationObj.user_visit_id = this.vid;
          this.changeRoute();
          return true;
        }
        return false;
      };
      const payload = {
        user_visit_id: this.vid,
        search_value: this.paginationObj.search_value
      }

      this.visitService.verify_krollid_rx_befor_create(payload).subscribe(
        (res) => {
          const data = res['body']?.data;
          const openDialog = () => {
            const dialogRef = this.dialog.open(ConfirmationRxBeforeCreateComponent, {
              width: '500px',
              data: data
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result && triggerSearch()) {
                return;
              }
              this.isRxSubmitLoading = false;
            });
          };
          if (data?.other_users_rx.length) {
            openDialog();
            return;
          }
          if (data?.other_users_rx.length === 0 && data?.same_user_rx.length) {
            if (data?.check_wylo_rx_for_din.match === true) {
              if (!triggerSearch()) {
                this.isRxSubmitLoading = false;
              }
            } else {
              openDialog();
            }
            return;
          }
          this.isRxSubmitLoading = false;
        },
        (error) => {
          this.toastr.error(error.message || 'Something went wrong');
          console.error('Error:', error);
          this.isRxSubmitLoading = false;
          //item.acuteRXID.isLoading = false;
        }
      );
    }
  }
  openProcessOrderModel() {
    // Prevent multiple clicks while request is in progress
    if (this.isProcessOrderLoading) {
      return;
    }
    
    this.isProcessOrderLoading = true;
    const filterList = Array.isArray(this.filterPatientList) ? this.filterPatientList : [];
    const orderIdsArray = filterList.map((item: any) => item.ID);
    const payload = { orderIds: orderIdsArray };

    this.shippingService.check_order_addr_match(payload).subscribe({
      next: (res: any) => {
        if (res.body.success) {
          const showPopup = res.body.data?.show_address_popup == 1;
          const hasAddresses = res.body.data?.address_list?.length > 0;
          if (showPopup && hasAddresses && (this.tenant == 'pl' || this.tenant == 'sl' || this.tenant == 'wylo' || this.tenant == 'ml')) {
            this.isProcessOrderLoading = false;
            // open address match popup with list of addresses
            this.openAddressMatch(res.body.data.address_list);
          } else {
            this.processOrder(); // common function call
          }
        }
      },
      error: (err: any) => {
        this.isProcessOrderLoading = false;
        this.toastr.error(err.message[0] || 'Something went wrong');
      }
    });
  }

  openAddressMatch(item: any) {
    try {
      const dialogConfig = new MatDialogConfig();
      let dialogRef;
      dialogConfig.disableClose = true;
      dialogConfig.data = { item };
      if (window.innerWidth < 768) {
        dialogConfig.width = "90%";
      }
      else {
        dialogConfig.width = "75%";
      }
      dialogRef = this.dialog.open(AddressMatchPopupComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(res => {
        if (Array.isArray(res) && res.length) {
          res.forEach((item: any) => {
            const updatedData = item?.response?.body?.data;
            if (updatedData?.item?.OrderID) {
              const index = this.response.list.findIndex((x: any) => {
                return x.OrderID == updatedData?.item?.OrderID;
              });
              if (index != -1) {
                this.response.list[index].Address1 = updatedData?.item?.Address1;
                this.response.list[index].City = updatedData?.item?.City;
                this.response.list[index].Prov = updatedData?.item?.Prov;
                this.response.list[index].Postal = updatedData?.item?.Postal;
                this.response.list[index].Country = updatedData?.item?.Country;
                this.response.list[index].Address2 = updatedData?.item?.Address2;
                this.response.list[index].UserAddressDetailId = updatedData?.item?.UserAddressDetailId;
              }
            }
          });
          this.processOrder(); // common function call
        }

      });
    } catch (error) {
      console.log(error);
    }
  }

  processOrder() {
    let payload: any = {};
    this.isProcessOrderLoading = true;
    this.shippingService
      .setCheckRatePayload(
        this.senderInformation,
        this.filterPatientList,
        this.formService.selectedLocation.value
      )
      .then((result) => {
        this.isProcessOrderLoading = false;
        payload = result;
        payload.Shipments.forEach((s: any) => {
          s.Shipment.PrinterType = 'Thermal';
          const salesID = s.SalesOrderID;
          const tagData = this.tagsValue?.[salesID] || {};
          s.Shipment.order_tag = tagData.order_tag || [];
          s.Shipment.client_tag = tagData.client_tag || [];
          const selectedDate = this.deliveryDates?.[salesID];
          const deliveryDate = selectedDate ? this.formatDateonSave(new Date(selectedDate)) : this.formatDateonSave(this.getCurrentDate());
          s.Shipment.deliverydate = deliveryDate;
        });
        payload.NotifyUsers = false;
        payload.NotifyUsersBy = [];
        const data = {
          orders: this.filterPatientList,
          payload: payload,
        };
        this.modalService.openWarningOrderDialog(
          data,
          this.paginationObj.shipping_type,
          this.get_patient_orders.bind(this)
        );
      });
  }

  openProcessPaymentDialog() {
    this.modalService.openNotificationDialog(
      this.filterPatientList,
      this.selectedPaitents[this.paginationObj.shipping_type],
      this.get_patient_orders.bind(this)
    );
  }
  deleteSalesOrders() {
    const dialogRef = this.dialog.open(DeleteConfirmPopUpComponent, {
      width: '500px',
      data: {
        title: 'Confirmation',
        message: 'Are you sure you want to delete the selected record(s)?',
        button: 'Delete'
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.response) {
          if (
            this.filterPatientList &&
            this.selectedPaitents[this.paginationObj.shipping_type].length > 0
          ) {
            let payload = this.filterPatientList.map((m: any) => m.ID);
            this.progress_spinner = true;
            this.krollService.delete_sales_order(payload).subscribe(
              (res) => {
                if (res.body.success) {
                  if (
                    this.response.pagination.last == this.paginationObj.page &&
                    this.filterPatientList.length == this.response.list.length
                  ) {
                    this.paginationObj.page = this.config.currentPage =
                      this.paginationObj.page - 1;
                    this.changeRoute();
                  } else {
                    this.get_patient_orders();
                  }
                  this.krollService.get_sales_order_status({
                    server_location: this.formService.selectedLocation.value,
                  });
                  this.toastr.success(res.body.message[0]);
                } else {
                  this.progress_spinner = false;
                  this.toastr.error(res.body.message[0]);
                }
              },
              (err) => {
                this.progress_spinner = false;
                this.toastr.error(err.message[0]);
              }
            );
          }
        }
      }
    });
  }
  addRxId(event: MatChipInputEvent, item: any): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim() && !item.acuteRXID.rxIds.includes(value)) {
      item.acuteRXID.rxIds.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
  }
  removeRxId(val: any, item: any): void {
    const index = item.acuteRXID.rxIds.indexOf(val);
    if (index >= 0) {
      item.acuteRXID.rxIds.splice(index, 1);
    }
  }
  openSignatureModal(item: any) {
    const dialogRef = this.dialog.open(SignatureModalComponent, {
      width: '450px',
      data: item.SignatureValue,
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        item.SignatureValue = result;
      }
    });
  }
  removeAcApplied(row: any) {
    const dialogRef = this.dialog.open(RemoveAcAppliedModal, {
      width: '500px',
      data: {
        rowData: row,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.get_patient_orders();
      }
    });

  }
  getPatientOrderByAcuteIds(item: any) {
    if (item.acuteRXID.rxIds.length > 0) {
      let payload = {
        search_by: SearchBy.Kroll,
        server_location: this.paginationObj.server_location,
        shipping_type: PatientType.Acute,
        search_value: item.acuteRXID.rxIds,
        user_id: item.UserID,
        order_id: item.OrderID,
        sales_order_id: item.ID,
        kroll_id: item.KrollID,
        request_order_id: item.RequestOrderID ? item.RequestOrderID : 0
      };
      item.acuteRXID.isLoading = true;
      this.krollService.get_patient_order_acute_rxnums(payload).subscribe(
        (res) => {
          item.acuteRXID.isLoading = false;
          let index = this.response.list.findIndex((f) => f.ID == item.ID);
          if (res['body']['code'] == 200) {
            item.acuteRXID.error = '';
            this.response.list[index] = {
              ...res['body']['data'][0],
              acuteRXID: item.acuteRXID,
            };
          } else if (res['body']['code'] == 206) {
            item.acuteRXID.error = res['body']['message'][0];
            this.response.list[index] = {
              ...res['body']['data'][0],
              acuteRXID: item.acuteRXID,
            };
          } else {
            item.acuteRXID.error = res['body']['message'][0];
          }
        },
        (error) => {
          item.acuteRXID.isLoading = false;
        }
      );
    }
  }
  openPromoCode(item: any) {
    let data = {
      id: item.ID,
      promoId: item.promoCode ? item?.promoCode?.id : null,
      user_id: item.UserID,
    };
    if (!data.promoId) {
      delete data.promoId;
    }
    const dialogRef = this.dialog.open(UserPromoComponent, {
      width: '80',
      height: 'auto',
      maxHeight: '550px',
      data: data,
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.get_patient_orders();
        // location.reload()
      }
    });
  }

  selectedOptionCode: any;

  get_discover_services(
    item: any,
    OptionCode?: any,
    isDimensionChange?: boolean
  ) {
    let payload: any = {
      Location: 1,
      CountryCode: 'CA',
      Locale: 'EN',
      OrderID: item.OrderID,
      OptionCode: isDimensionChange ? item?.OptionCode : OptionCode?.value,
      OptionAmount: item.PaymentDue,
      SenderInformation: {
        PostalCode: this.senderInformation?.PostalCode,
      },
      ReceiverInformation: {
        PostalCode: item.Postal,
      },
      ParcelCharacteristics: {
        Weight: item?.Measurments?.Weight,
        Length: item?.Measurments?.Length,
        Width: item?.Measurments?.Width,
        Height: item?.Measurments?.Height,
        Unpackaged: false,
        MailingTube: false,
      },
    };
    this.krollService.get_discover_services(payload).subscribe(
      (res: any) => {
        if (res) {
          this.discoverServiceList = res.body.data;
          item.discoverServiceList = res.body.data;
        }
      },
      (error: any) => { }
    );
  }

  dropdownClicked(item: any) {
    // if (!item?.discoverServiceList || item?.discoverServiceList?.length == 0) {
    this.get_discover_services(item);
    // }
  }

  get_options() {
    let payload: any = {
      Locale: 'EN',
    };
    this.krollService.get_options(payload).subscribe((res: any) => {
      if (res) {
        //this.optionList = res.body.data
        // this.optionList.map((item: any) => { item.disabled = false })
      }
    });
  }
  checkCanadaPost(item: any) {
    this.shippingService.deliveryPartnerName = item;
    //console.log("this.formService.addDeliveryPartner.value",this.formService.addDeliveryPartner.value)
    // console.log("item",item)

    //if (item == 'Canada Post') {

    if (item == 13) {
      this.isShowCanadaPost = true;
      this.isShowMWSPost = false;
      this.response.list = this.response.list.map((m) => ({
        ...m,
        isShowCanadaPostOption: true,
        isShowMWSPostOption: false,
      }));
    } else if (item == 9 && this.serverLocation == 1) {
      this.isShowCanadaPost = false;
      this.isShowMWSPost = true;
      this.response.list = this.response.list.map((m) => ({
        ...m,
        isShowCanadaPostOption: false,
        isShowMWSPostOption: true,
      }));
      this.getMWSOptions();
      this.initializeDeliveryDate(this.response.list);
    }
    else {
      this.response.list = this.response.list.map((m) => ({
        ...m,
        isShowCanadaPostOption: false,
        isShowMWSPostOption: false,
      }));
      this.isShowCanadaPost = false;
      this.isShowMWSPost = false;
    }
  }

  setDiscoverSevice(saleOrder: any, ServiceCode: any) {
    saleOrder.ServiceCode = ServiceCode;
  }

  setOption(saleOrder: any, OptionCode: any) {
    saleOrder.OptionCode = OptionCode;
  }

  getUpdatedDiscoveryService() {
    this.modalService.getUpdatedDiscoveryService.subscribe((res: any) => {
      if (res) {
        this.get_discover_services(res, this.selectedOptionCode, true);
      }
    });
  }

  getDeliveryPartnerCanadaPost(item: any, event: any) {
    let partner = this.deliveryPartners.find((item) => item.id == event.value);
    this.shippingService.deliveryPartnerName = partner?.name;

    if (partner?.type == 'canada_post') {
      this.isShowCanadaPost = true;
      item.isShowCanadaPostOption = true;
      item.isShowMWSPostOption = false;
      this.isShowMWSPost = false;
      this.get_discover_services(item);
    } else if (partner?.type == 'mws' && this.serverLocation == 1) {
      item.isShowCanadaPostOption = false;
      item.isShowMWSPostOption = true;
      this.isShowMWSPost = true;
      this.initializeDeliveryDate(item);
    }
    else {
      item.isShowCanadaPostOption = false;
      item.isShowMWSPostOption = false;
      // Check for Canada Post Option
      this.isShowCanadaPost = this.response.list.some(
        (responseItem) => responseItem.isShowCanadaPostOption
      );
      // Check for MWS Post Option
      this.isShowMWSPost = this.response.list.some(
        (responseItem) => responseItem.isShowMWSPostOption
      );
    }


  }
  /*   getDeliveryPartnerCanadaPost(item: any, event: any) {

      let partner = this.deliveryPartners.find((item) => item.id == event.value);
      this.shippingService.deliveryPartnerName = partner?.name;

      if (partner?.type == 'canada_post') {
          item.isShowCanadaPostOption = this.isShowCanadaPost;
          this.get_discover_services(item);
      } else {
          item.isShowCanadaPostOption = false;
      }
      // Check if at least one true value exists in isShowCanadaPostOption
      const isAnyTrue = this.response.list.some((responseItem) => responseItem.isShowCanadaPostOption === true);
      this.isShowCanadaPost = isAnyTrue;
  } */

  autoSelectAndDisableEnableOption(
    item: { OptionCode: string | string[] },
    event: any
  ): void {
    // Reset disabled for all options
    this.optionList.forEach((option: Option) => (option.disabled = false));

    // Handle auto-check options based on autoCheckOption
    if (Array.isArray(item.OptionCode)) {
      this.optionList.forEach((option: Option) => {
        if (
          item.OptionCode.includes(option.OptionCode) &&
          Array.isArray(option.autoCheckOption) &&
          option.autoCheckOption.length > 0
        ) {
          item.OptionCode = [...item.OptionCode, ...option.autoCheckOption];
        }
      });
    }

    // Check if OptionCode is an array and handle accordingly
    const selectedOptions: Option[] = this.optionList.filter(
      (option: Option) => {
        if (Array.isArray(item.OptionCode)) {
          return item.OptionCode.includes(option.OptionCode);
        } else {
          return option.OptionCode === item.OptionCode;
        }
      }
    );

    // Disable options based on desableOption
    selectedOptions.forEach((selectedOption: Option) => {
      selectedOption.desableOption.forEach((code: string) => {
        const optionToDisable: Option | undefined = this.optionList.find(
          (option: Option) => option.OptionCode === code
        );
        if (optionToDisable) {
          optionToDisable.disabled = true;
        }
      });
    });
  }

  get_discover_services_general() {
    let payload: any = {
      CountryCode: 'CA',
      Locale: 'EN',
    };
    this.krollService.get_discover_services(payload).subscribe(
      (res: any) => {
        if (res) {
          this.discoverServiceList = res.body.data;
          this.response.list.map((m: any) => {
            m.discoverServiceList = res.body.data;
          });
        }
      },
      (error: any) => { }
    );
  }

  mwsOptionFilter(item: any, event: any) {
    const selectedIds = event.value;

    const order_tag = this.mwsOptionList
      .filter(opt => selectedIds.includes(opt?.info?.id) && opt.type.toLowerCase() == 'order')
      .map(opt => ({
        type: opt.type,
        label: opt.label,
        shortLabel: opt.shortLabel,
        icon: opt.icon,
        color: opt.color,
        system: opt.system
      }));

    const client_tag = this.mwsOptionList
      .filter(opt => selectedIds.includes(opt?.info?.id) && opt.type.toLowerCase() == 'client')
      .map(opt => ({
        type: opt.type,
        label: opt.label,
        shortLabel: opt.shortLabel,
        icon: opt.icon,
        color: opt.color,
        system: opt.system
      }));

    // Store by SalesOrderID (item.ID)
    if (!this.tagsValue) this.tagsValue = {};
    this.tagsValue[item.ID] = {
      order_tag: order_tag.length ? order_tag : [],
      client_tag: client_tag.length ? client_tag : []
    };
  }

  getCurrentDate(): Date {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Reset time to midnight for consistency
    return currentDate;
  }


  initializeDeliveryDate(items: any[]) {
    const itemList = Array.isArray(items) ? items : [items];
    itemList.forEach((item) => {
      if (!this.deliveryDates[item.ID]) {
        this.deliveryDates[item.ID] = this.getCurrentDate(); // set current date if not set
      }
    });
  }

  onDateChange(event: any, item: any) {
    if (event instanceof Date) {
      const formattedDate = this.formatDate(event);
      this.deliveryDates[item.ID] = formattedDate; // change the format into 'YYYY-MM-DD'
      this.sendDeliveryDate = formattedDate;
    }
  }

  formatDateonSave(date: Date): string {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      throw new Error("Invalid date provided to formatDate");
    }
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Adds leading zero if needed
    const day = ('0' + date.getDate()).slice(-2); // Adds leading zero if needed
    return `${year}-${month}-${day}`; // Returns date in 'YYYY-MM-DD' format
  }

  formatDate(date: Date): Date {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      throw new Error("Invalid date provided to formatDate");
    }
    const normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0); // Reset time to midnight
    return normalized;
  }

  navigateToPatientProfile(id: any) {
    this.patientService.route = '/portal/users';
    window.open('patient/detail/' + id, '_blank');
  }

}

interface Option {
  OptionCode: string;
  OptionName: string;
  OptionClass: string;
  desableOption: string[];
  autoCheckOption: string[];
  disabled?: boolean;
}
